/**
 * 活动页面 API 调用
 */
import { getWisdomConfig, preloadWisdomClient } from '@/shared/wisdom';
import { ubtSendError } from '@/shared/utils/ubt';
import type { Ref } from '@vue/composition-api';
import type { ActivityHomeConfig, WisdomConfigData } from './types';
import { DEFAULT_FALLBACK_CONFIG } from './config';

const ACTIVITY_HOME_CONFIG_KEY = 'activityHomeConfig';

const formatToUseWebpImage = (
  config: ActivityHomeConfig,
  isSupportWebp = false,
): ActivityHomeConfig => {
  if (isSupportWebp) {
    config.orderComponents.forEach((component) => {
      if (component.backgroundImage?.webp) {
        component.backgroundImage.default = component.backgroundImage.webp;
      }
    });
  }

  return config;
};

/**
 * 查询页面活动展示配置
 * @param activityType 活动类型
 */
export const getActivityHomeConfig = async (
  activityType: string,
  isSupportWebp = false,
): Promise<ActivityHomeConfig> => {
  try {
    /**
     * 读取wisdom配置平台，接口path：/wisdom-config/v1/，key：activityHomeConfig
     * 平台链接：https://config.hellobike.cn/#/project/detail?projectGuid=8fa0876b0e60472b9cbf257a9bc63ad4&projectName=AppFinanceH5Web
     */
    const config = await getWisdomConfig<WisdomConfigData>(ACTIVITY_HOME_CONFIG_KEY);
    const activityConfig = config[activityType] || DEFAULT_FALLBACK_CONFIG;

    return formatToUseWebpImage(activityConfig, isSupportWebp);
  } catch (error) {
    ubtSendError({
      name: `getActivityHomeConfig-error-${activityType}`,
      message: `url:${window.location.href}`,
    });

    return formatToUseWebpImage(DEFAULT_FALLBACK_CONFIG, isSupportWebp);
  }
};

/**
* 异步赋值辅助函数
* 用于简化异步数据赋值到 Vue ref 的操作
*/
export function assignAsync<T>(ref: Ref<T>, resultPromise: Promise<T>): Promise<void> {
  return resultPromise.then((res: T) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    (ref as { value: T }).value = res;
  });
}

/** 预初始化wisdom-sdk实例 */
preloadWisdomClient();
